import { render, staticRenderFns } from "./SubCompaniesForm.vue?vue&type=template&id=05346634&scoped=true&"
import script from "./SubCompaniesForm.vue?vue&type=script&lang=js&"
export * from "./SubCompaniesForm.vue?vue&type=script&lang=js&"
import style0 from "./SubCompaniesForm.vue?vue&type=style&index=0&id=05346634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05346634",
  null
  
)

export default component.exports